import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import CGridstack from 'components/CGridstack';

import moment from "moment";
import 'moment/locale/fr';
import Swal from "sweetalert2";
import * as commonFunc from 'scripts/common';

import {
    Button, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter,
    Row, Col, Card, CardHeader, CardTitle, CardBody, Form, ButtonGroup, FormGroup, Nav, NavItem, NavLink
} from "reactstrap";

import { Menu, Item, useContextMenu } from "react-contexify"
import "react-contexify/dist/ReactContexify.css";

import Select from 'react-select';

import AGenerateModel, { getRgbaFromHex, convertWidthToGrid } from 'components/generic/AGenerateModel';
import PictureFrag from 'components/generic/PictureFrag';
import AConfigureModel, { prepareModelToSave } from 'components/generic/AConfigureModel';
import AHTMLModel from 'components/genericHtml/AHTMLModel';

class Home extends Component {
    static displayName = Home.name;

    static siteModels;

    static modalRoot;
    static user;

    constructor(props) {
        super(props);

        /*var optDataKey = localStorage.getItem("optionsTDB");
        if (optDataKey === null) {
            localStorage.setItem('optionsTDB', JSON.stringify(defaultGridStackData));
        }
        else {
            defaultGridStackData = JSON.parse(optDataKey);
        }*/

        this.state = { /*gridData: JSON.stringify(defaultGridStackData),*/ render: false, versionning: "" };
    }

    componentDidMount() {
        //if (this.props.updateUser) this.props.updateUser();

        var context = this;
        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            context.user = curUser;
            var srcRoles = curUser.roles;
            var haveCustomProfiles = curUser.roles.filter(role => role.startsWith("PRFL_"));
            srcRoles = haveCustomProfiles?.length ? haveCustomProfiles : srcRoles;
            var targetRoles = srcRoles ? srcRoles[0] : null;

            //commonFunc.getMethod("../api/site/GetSiteModels", { id: -1, categ: "WIDGET" }).then((responseModels) => {
            //commonFunc.getMethod("../api/site/GetSiteModelsList", { id: -1, categ: "WIDGET" }).then((responseModels) => {
            commonFunc.getMethod("../api/data/GetAllModels", { filter: "site", categ: "WIDGET", useParentSite: true, excludeMode: 1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    var localGridData;
                    var srcModel;
                    context.siteModels = {};
                    //var models = dataModels.result;//dataModels.result.models
                    var models = dataModels.result.map(keyItem => keyItem.tag);//dataModels.result.models
                    var resFilter = models?.filter((model) => {
                        if (model.extID === "CFG_HOME") {
                            if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                                srcModel = model;
                            }
                        }

                        context.siteModels[model.extID] = JSON.parse(model.value);

                        return model.extID === "CFG_HOME_" + targetRoles;
                    });
                    if (resFilter && resFilter.length) {
                        localGridData = resFilter[0].value;
                    }
                    else if (srcModel) {
                        localGridData = srcModel.value;
                    }
                    else {
                        //Pour les site qui n'ont pas de configuration de paramètré
                        var localConfig = [
                            { id: "gs-storage", hidden: false, type: "WGT_STORAGE", title: "Fichiers Stockés", x: 0, y: 0, w: 3, h: 2, versionGrid: "" },
                            { id: "gs-download", hidden: false, type: "WGT_DOWNLOAD", title: "Fichiers Téléchargés", "data": 0, "altData": 0, x: 3, y: 0, w: 3, h: 2 },
                            { id: "gs-email", hidden: false, type: "WGT_EMAIL", title: "Emails", "data": 0, x: 6, y: 0, w: 3, h: 2 },
                            { id: "gs-sms", hidden: false, type: "WGT_SMS", title: "Sms", "data": 0, x: 9, y: 0, w: 3, h: 2 },
                            { id: "gs-lastusers", hidden: false, type: "WGT_LASTUSERS", title: "Derniers Comptes", x: 0, y: 2, w: 6, h: 6 },

                            { id: "gs-lastact", hidden: false, type: "WGT_LASTACT", title: "Actions récentes", x: 6, y: 2, w: 6, h: 6 },
                            { id: "gs-payments", hidden: true, type: "TABLE", title: "Départs à solder", x: 0, y: 8, w: 6, h: 5 },
                            { id: "gs-activity", hidden: true, type: "TABLE", title: "Suivi des Activités", x: 6, y: 8, w: 6, h: 5 },
                            { id: "gs-userscon", hidden: false, type: "CHART_USERSCON", "data": 0, title: "Utilisateur(s) en Ligne", x: 0, y: 13, w: 6, h: 5 },
                            { id: "gs-usersact", hidden: true, type: "TABLE", title: "Comptes Utilisateurs actifs", x: 10, y: 13, w: 4, h: 5 },
                            //{ id: "gs-network", hidden: false, type: "WGT_NETWORK", title: "Latence Réseau (ms)", x: 6, y: 13, w: 2, h: 2 },
                            //{ id: "gs-subs", hidden: false, type: "TABLE", title: "Abonnements SAAS", x: 10, y: 14, w: 2, h: 2 },
                            //{ id: "gs-plugins", hidden: false, type: "TABLE", title: "Modules Extension", x: 10, y: 16, w: 2, h: 2 },
                        ];
                        localGridData = JSON.stringify(localConfig);
                    }

                    var itemVersionning = "";
                    if (localGridData && localGridData.length) {
                        var temp = JSON.parse(localGridData);
                        if (temp?.length) itemVersionning = (!commonFunc.isBlank(temp[0].versionGrid) ? ("_" + temp[0].versionGrid) : "");
                    }
                    context.setState({ gridData: localGridData, render: !context.state.render, versionning: itemVersionning });

                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });


            //Gestion Swal/Dialog 1ere ouverture
            var siteForDialog = context.props.getSite();
            if (siteForDialog) {
                var siteExtras = siteForDialog.extras;
                if (!context.modalRoot && curUser && curUser.primarySId >= 3 && (!(siteForDialog.parentID > 0) && !(siteExtras && siteExtras.length && siteExtras.filter(extra => extra.name === "dialogTuto").length > 0))) {//rightsType.manager+   //TEMP : voir quel test appliquer (passer à 4 pour ADMIN)
                    var title = "Premiers pas";

                    if (context.modalRoot) {
                        context.modalRoot.unmount();
                        context.modalRoot = null;
                    }

                    //Traitement des informations retourné par le Dialog
                    var callbackModal = function (data, isUpdate) {
                        return new Promise(async (resolve, reject) => {
                            if (data) {

                                var asyncJobs = [];
                                var mainResponse;

                                console.debug(data.modalToSave);
                                data.modelsToSave.forEach((model) => {
                                    var args = {};
                                    var url = "api/" + model.entity;
                                    if (model.idModel) {
                                        url += "/Update";
                                        args.idModel = model.idModel;
                                    }
                                    else {
                                        url += "/Add";
                                        args.idModel = 0;
                                    }
                                    url += model.entity;
                                    url += "Model";

                                    args.title = "Saved Model";
                                    args.extID = "SAVED-" + model.extID;
                                    args.categ = model.categ;
                                    args.value = model.value;

                                    console.debug(args);

                                    commonFunc.postMethod("../" + url, args).then((response) => {
                                        var data = response.data;
                                        if (data.isSuccess) {
                                            Swal.fire({
                                                icon: "success",
                                                title: "Succès",
                                                html: "Sauvegarde de modèle effectuée avec succès.",
                                                didOpen: () => {
                                                    Swal.hideLoading();
                                                },
                                                allowOutsideClick: false,
                                                allowEscapeKey: false,
                                                allowEnterKey: false,
                                            }).then((result) => {
                                                //window.location.reload();
                                            });
                                        }
                                        else {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Echec",
                                                html: "Echec de sauvegarde<br/>" + response.data.errorMessage
                                            });
                                        }
                                    });
                                });


                                //resolve(mainResponse);
                                //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP

                                //Enregistrement des salariés
                                var employees = data.employees;
                                if (employees && Object.keys(employees).length) {
                                    //Appeler un CreateEmployee pour chaque employee
                                    Object.keys(employees).forEach(async (employeeKey, index) => {
                                        var employee = employees[employeeKey];
                                        if (employee && employee.idEmployee === 0 && !employee.added) {
                                            employee.added = true;
                                            asyncJobs[index] = await commonFunc.postMethod("../api/employee/CreateEmployee", employee).then((response => {
                                                return new Promise(resolve => {
                                                    resolve(response);
                                                });
                                            })).catch(error => {
                                                return new Promise((resolve) => {
                                                    resolve({ isSuccess: false, errorMessage: error });
                                                });
                                            });
                                        }
                                    });
                                    //delete data.employees
                                }

                                //Upload Site Avatar
                                //if (pictureData.functionManager && pictureData.functionManager.onSubmit) pictureData.functionManager.onSubmit(null, -1);//TODO : idSite ???

                                var curSiteID = curUser.groupSId || -1;
                                var file = data.file;
                                if (file && !file.closed) {
                                    const formData = new FormData();

                                    var fileUpReq = {
                                        name: file.name,
                                        ftype: file.docType || data.argumentsObj.ftype || "AVA",
                                        bindType: data.argumentsObj.bindType || "",
                                        visibility: 1,
                                        language: "FR",
                                        //fbindId: props.fileTypeID, //Type
                                        bindId: curSiteID,
                                        //bindSubId
                                        fileTypeID: file.docTypeId || data.argumentsObj.fileTypeID,
                                        lastModified: file.lastModifiedDate,
                                        saveProperty: data.argumentsObj.saveProperty || data.bindPropResult,
                                        savePropertyAsUrl: data.argumentsObj.savePropertyAsUrl || false
                                    };

                                    formData.append('file', file);
                                    formData.append('args', JSON.stringify(fileUpReq));


                                    const onUploadProgress = (event) => {
                                        console.debug(event);

                                        file.loaded = event.loaded;
                                        file.total = event.total;
                                        file.progress = Math.round(100 * event.progress);
                                        //setSelectedFile(file);
                                    };
                                    asyncJobs.push(await axios.post(data.argumentsObj.url || "../api/data/UploadFiles", formData, { headers: { "Content-Type": "multipart/form-data", }, onUploadProgress }).then((response => {
                                        file.closed = true;
                                        if (response.data.isSuccess) {
                                            file.validated = true;
                                        }
                                        else {
                                            file.error = response.data.errorMessage;
                                        }
                                        //setSelectedFile(file);
                                        return new Promise(resolve => {
                                            resolve(response);
                                        });
                                    })).catch(error => {
                                        return new Promise((resolve) => {
                                            resolve({ isSuccess: false, errorMessage: error });
                                        });
                                    }));
                                }



                                asyncJobs.push(await commonFunc.postMethod("../api/data/UpdateClientSettings", data).then((async response => {
                                    mainResponse = response;
                                    return new Promise(resolve => {
                                        resolve(response);
                                    });
                                })).catch(error => {
                                    return new Promise((resolve) => {
                                        resolve({ isSuccess: false, errorMessage: error });
                                    });
                                }));


                                if (asyncJobs.length) {
                                    Promise.all(asyncJobs).then(results => {
                                        console.debug(results);
                                        var errorMessage = false;
                                        var flagSuccess = true;
                                        results.forEach(res => {
                                            if (res && res.data) {
                                                flagSuccess &= res.data.isSuccess;
                                                if (!res.data.isSuccess) errorMessage = res.data.errorMessage;
                                            }
                                            else {
                                                flagSuccess = false;
                                                errorMessage = res.errorMessage;
                                            }
                                        });

                                        if (flagSuccess) {
                                            Swal.fire({
                                                icon: "success",
                                                title: "Succès",
                                                html: "Modifications effectuées avec succès.",
                                                didOpen: () => { Swal.hideLoading(); },
                                                allowOutsideClick: false,
                                                allowEscapeKey: false,
                                                allowEnterKey: false,
                                            }).then((result) => {
                                                window.location.reload();
                                            });

                                            context.modalRoot.unmount();
                                            resolve(mainResponse);
                                        }
                                        else {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Erreur",
                                                html: "Erreur lors de l'enregistrement des informations :<br>" + errorMessage
                                            });
                                        }
                                        return;

                                    }, rej => {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Erreur",
                                            html: "Erreur de l'enregistrement des informations :<br>" + rej.message
                                        });
                                    })
                                        .catch(error => {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Erreur",
                                                html: "Erreur de l'enregistrement des informations :<br>" + error.message
                                            });
                                        });
                                }
                            }
                            else {
                                context.modalRoot.unmount();
                                resolve();
                            }
                        });
                    };
                    context.modalRoot = createRoot(document.createElement('div'));
                    context.modalRoot.render(<InitModal parentContext={context} title={title} modelsList={null} callback={callbackModal}></InitModal>);
                }
            }
        });
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount();
            this.modalRoot = null;
        }
    }

    render() {

        //console.debug(this.state.gridData);
        //console.debug(this.siteModels);


        document.body.classList.add("sidebar-mini");


        var appState = this.props.getAppState();
        var mDate;
        var endDate = "N/A";
        var subscription = appState?.subscription;
        if (subscription?.endDate) {
            mDate = commonFunc.restStringToDate(subscription.endDate);
            if (commonFunc.isValidDate(mDate) && mDate.getFullYear() > 1970) {
                endDate = commonFunc.formatDateDMY(moment(mDate).utc(true).toDate());
            }
        }

        var siteForDialog = this.props.getSite();
        var siteExtras = siteForDialog?.extras;

        //Affichage des boutons paramètrages gridstack
        var hideButtons = false;
        if (this.props.dataCfg?.gridButtons?.home?.startsWith) {
            if (this.props.dataCfg.gridButtons.home.startsWith("roles:")) {
                hideButtons = true;
                var targetRoles = this.user?.roles ? this.user?.roles : null;
                var requiredRoles = this.props.dataCfg?.gridButtons.home.replace("roles:", "");
                var splitR = requiredRoles.split(";");
                targetRoles?.forEach((role) => {
                    hideButtons &= !(splitR.indexOf(role) >= 0);
                });
            }
            else if (this.props.dataCfg.gridButtons.home.startsWith("excludedRoles:")) {
                var targetERoles = this.user?.roles ? this.user?.roles : null;
                var excludedRoles = this.props.dataCfg?.gridButtons.home.replace("excludedRoles:", "");
                var splitExcludedR = excludedRoles.split(";");
                targetERoles?.forEach((role) => {
                    if (splitExcludedR.indexOf(role) >= 0) hideButtons = true;
                });
            }
        }
        else if (this.props.dataCfg?.gridButtons?.home === false) {
            hideButtons = true;
        }

        return this.user && this.state.gridData ? (
            <div>
                {this.user.primarySId >= 3 && !(siteExtras?.length && siteExtras.filter(extra => extra.name === "dialogTuto").length > 0) ? <h1 className="mb-1">Bienvenue</h1> : ""}

                {subscription ? <h5 className="title mb-2">{subscription?.product?.name || "N/A"} {subscription?.product?.description || "N/A"}</h5> : ""}
                


                {appState?.subscription?.isTrial ? <div class="alert alert-secondary text-dark cursor-pointer" role="alert" onClick={(e) => { e.preventDefault(); this.props.navigate("/ManageSubscriptions"); }}>
                    <h5>Vous êtes actuellement connecté en Version d'essai</h5>
                        Pour activer votre abonnement, cliquer ici</div> : <>
                    {appState?.showAlert === 1 ? <div class="alert alert-warning text-dark cursor-pointer" role="alert" onClick={(e) => { e.preventDefault(); this.props.navigate("/ManageSubscriptions"); }}>
                        <h5><i className="fa fa-triangle-exclamation me-2" title="Expiration Abonnement proche"></i>Votre abonnement {appState?.subscription?.product?.name} approche de sa date d'expiration ! </h5>
                        Pour prolonger votre abonnement et éviter toute interruption de service à partir de {endDate}, cliquer ici pour renouveler votre abonnement</div> : ""}
                    {appState?.showAlert === 2 ? <div class="alert alert-danger cursor-pointer" role="alert" onClick={(e) => { e.preventDefault(); this.props.navigate("/ManageSubscriptions"); }}>
                        <h5><i className="fa fa-triangle-exclamation me-2" title="Expiration Abonnement proche"></i>Votre abonnement {appState?.subscription?.product?.name} est sur le point d'expirer ! </h5>
                        Pour prolonger votre abonnement et éviter toute interruption de service à partir de {endDate}, cliquer ici pour renouveler votre abonnement</div> : ""}
                </>}
                <CGridstack type={"optionsTDB" + (this.user.groupSId || "") + this.state.versionning} dbClientID={((this.user.clientID + "_") || "")} data={this.state.gridData} configModel={this.siteModels} gridClass={""} actionsClass={"text-secondary"}
                    parentProps={{ type: "wgt", dataCfg: this.props.dataCfg }} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} hideButtons={hideButtons} />
            </div>
        ) : "";
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}
const withNavigate = (Component) => {
    return props => {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />
    }
}


export default withI18n(withNavigate(Home));




//Dialog d'initialisation d'environnement
function InitModal({ title, parentContext, noScroll, modelsList, dataReport, callback }) {
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? parentContext.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

    React.useEffect(() => {
        //console.debug("mount");

        initModal();

        return () => {
            //console.debug("unmount");
            if (window.modalContainer) {
                window.modalContainer.unmount();
                window.modalContainer = null;
            }
        }
    }, []);

    const [shouldRender, setShouldRender] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState();
    const [siteName, setSiteName] = React.useState("");


    const [selectedTab, setSelectedTab] = React.useState("1");

    //STEP 1
    const [activities] = React.useState([
        { "label": "Tous", "value": "*" }, { "label": "Déménagement", "value": "DEMENAG" }, { "label": "Recherche de fuite", "value": "RFND" }, { "label": "Aide à la personne", "value": "AD" }, { "label": "Bâtiment", "value": "BTM" }, { "label": "Immobilier", "value": "IMMOBILIER" }, { "label": "Transport", "value": "TRANS" }
    ]);
    const [currActivities, setCurrActivities] = React.useState(-1);
    const [currActivityInvalid, setCurrActivityInvalid] = React.useState(false);
    const [color1, setColor1] = React.useState("#103F58");//231D51
    const [color2, setColor2] = React.useState("#103F58");//FFFFFF
    const [color3, setColor3] = React.useState("#DDDDDD");//CC2026
    const [color4, setColor4] = React.useState("#FFFFFF");

    const [site, setSite] = React.useState(null);
    const [services, setServices] = React.useState([]);
    const [currServices, setCurrServices] = React.useState([]);
    const [models, setModels] = React.useState([]);
    const [currModel, setCurrModel] = React.useState(null);
    const [currModelHtml, setCurrModelHtml] = React.useState(null);
    const [homeModel, setHomeModel] = React.useState(null);

    const [currModelHome, setCurrModelHome] = React.useState("HOME_2");
    const [currModelReport, setCurrModelReport] = React.useState("DTL_REPORT_2");

    const [siteIsOpen, setSiteIsOpen] = React.useState(true);
    const [modelsIsOpen, setModelsIsOpen] = React.useState(true);
    const [employeesIsOpen, setEmployeesIsOpen] = React.useState(true);
    const [showFinalize, setShowFinalize] = React.useState(false);

    const [zoomValue, setZoomValue] = React.useState(0);

    const siteAvatarBtn = React.useRef();
    const modalGenManager = React.useRef();
    const reportGenManager = React.useRef();
    const reportGenHtmlManager = React.useRef();
    const employeeGenManager = React.useRef();

    const showContextMenu = useContextMenu().show;
    const hideAllMenu = useContextMenu().hideAll;

    //STEP 2
    const [employees, setEmployees] = React.useState({});


    var pictureData = {
        argumentsObj: { "url": "api/site/UploadSiteFiles", "ftype": "AVA", "value": "", "target": "IDSite", "trigger": "", "bindType": "SITE", "fileTypeID": 1, "saveProperty": "Avatar", "savePropertyAsUrl": true, cAcceptTypes: "image/png, image/gif, image/jpg, image/jpeg" },
        customDesign: {
            design: {
                "width": "95px",
                "height": "95px",
                "borderRadius": "50%"
            }
        }
    };

    //TODO
    var defaultSample = {
        "PREVIEW-NONE-9654097081-1": {
            idReport: 9999,
            extras: [
                { name: "listeDesordres", value: '["extras.listeDesordres.desordre_822129563"]' },
                { name: "desordre_822129563", value: '["extras.listeDesordres.desordre_822129563.disturbsTitleGrp_970533657","extras.listeDesordres.desordre_822129563.disturbsPhotoGrp_862198267","extras.listeDesordres.desordre_822129563.technique_2111129646","extras.listeDesordres.desordre_822129563.disturbsPhotoGrp_594881727","extras.listeDesordres.desordre_822129563.technique_121677086"]' },
                { name: "disturbsTitleGrp_970533657", value: '["extras.listeDesordres.desordre_822129563.disturbsTitleGrp_970533657.disturbsTitle_690407692","extras.listeDesordres.desordre_822129563.disturbsTitleGrp_970533657.disturbsTitleOther_1585944118"]' },
                { name: "disturbsTitle_690407692", value: '{"id":0,"tag":"A notre arrivée, nous constatons","value":"2"}' },
                { name: "disturbsTitleOther_1585944118", value: '' },
                { name: "disturbsPhotoGrp_862198267", value: '["extras.listeDesordres.desordre_822129563.disturbsPhotoGrp_862198267.disturbsPhoto_1898185846","extras.listeDesordres.desordre_822129563.disturbsPhotoGrp_862198267.disturbsPhotoComment_248463016"]' },
                { name: "disturbsPhoto_1898185846", value: '{"absoluteUri":"/report/2000/663796954_20250110_231252.jpg","bindID":2000,"bindType":"REPORT","categ":"PJ","contentType":"image/jpeg","dSysMod":"1970-01-01T00:00:00.000Z","extension":"","fileTypeID":8,"idFile":0,"isBlock":false,"isCached":false,"isEncrypted":false,"isFile":true,"isHidden":false,"isHosted":false,"isSent":false,"lang":"FR","lastModified":"2025-01-10T14:12:52.000Z","lastSyncedDate":"1970-01-01T00:00:00.000Z","length":76682,"localeUri":"/storage/emulated/0/Android/data/com.softena.oskalacore/files/Documents/2/1/report/2000/663796954_20250110_231252.jpg","name":"663796954_20250110_231252.jpg","rootContainer":"/storage/emulated/0/Android/data/com.softena.oskalacore/files/Documents/2/1/report/2000/663796954_20250110_231252.jpg","siteID":-1,"statusID":5001,"tenantFileSrcId":0,"useTimestamp":true}' },
                { name: "disturbsPhotoComment_248463016", value: 'test' },
                { name: "disturbsPhotoGrp_594881727", value: '["extras.listeDesordres.desordre_822129563.disturbsPhotoGrp_594881727.disturbsPhoto_926467359","extras.listeDesordres.desordre_822129563.disturbsPhotoGrp_594881727.disturbsPhotoComment_818242275"]' },
                { name: "disturbsPhoto_926467359", value: '{"absoluteUri":"/report/2000/774928455_20250110_231324.jpg","bindID":2000,"bindType":"REPORT","categ":"PJ","contentType":"image/jpeg","dSysMod":"1970-01-01T00:00:00.000Z","extension":"","fileTypeID":8,"idFile":0,"isBlock":false,"isCached":false,"isEncrypted":false,"isFile":true,"isHidden":false,"isHosted":false,"isSent":false,"lang":"FR","lastModified":"2025-01-10T14:13:24.000Z","lastSyncedDate":"1970-01-01T00:00:00.000Z","length":77173,"localeUri":"/storage/emulated/0/Android/data/com.softena.oskalacore/files/Documents/2/1/report/2000/774928455_20250110_231324.jpg","name":"774928455_20250110_231324.jpg","rootContainer":"/storage/emulated/0/Android/data/com.softena.oskalacore/files/Documents/2/1/report/2000/774928455_20250110_231324.jpg","siteID":-1,"statusID":5001,"tenantFileSrcId":0,"useTimestamp":true}' },
                { name: "disturbsPhotoComment_818242275", value: '' },

                { name: "technique_2111129646", value: '["extras.listeDesordres.desordre_822129563.technique_2111129646.titreTech_1917228370","extras.listeDesordres.desordre_822129563.technique_2111129646.commentaireTech_1771884546","extras.listeDesordres.desordre_822129563.technique_2111129646.photos_581899708"]' },
                { name: "titreTech_1917228370", value: '{"id":3,"tag":"Produit traçant & lampe à ultra-violet","value":"3"}' },
                { name: "commentaireTech_1771884546", value: 'test d1t1' },
                { name: "photos_581899708", value: '["extras.listeDesordres.desordre_822129563.technique_2111129646.photos_581899708.photoTech_291635153","extras.listeDesordres.desordre_822129563.technique_2111129646.photos_581899708.photoTech2_238279790","extras.listeDesordres.desordre_822129563.technique_2111129646.photos_581899708.commentGrp_2105687934"]' },
                { name: "photoTech_291635153", value: '{"absoluteUri":"/report/2000/2043398638_20250110_231345.jpg","bindID":-1,"bindType":"REPORT","categ":"PJ","contentType":"image/jpeg","dSysMod":"1970-01-01T00:00:00.000Z","extension":"","fileTypeID":8,"idFile":0,"isBlock":false,"isCached":false,"isEncrypted":false,"isFile":true,"isHidden":false,"isHosted":false,"isSent":false,"lang":"FR","lastModified":"2025-01-10T14:13:46.000Z","lastSyncedDate":"1970-01-01T00:00:00.000Z","length":69296,"localeUri":"/storage/emulated/0/Android/data/com.softena.oskalacore/files/Documents/2/1/report/2000/2043398638_20250110_231345.jpg","name":"2043398638_20250110_231345.jpg","rootContainer":"/storage/emulated/0/Android/data/com.softena.oskalacore/files/Documents/2/1/report/2000/2043398638_20250110_231345.jpg","siteID":-1,"statusID":5001,"tenantFileSrcId":0,"useTimestamp":true}' },
                { name: "photoTech2_238279790", value: '{"bindID":0,"dSysMod":"1970-01-01T00:00:00.000Z","fileTypeID":0,"idFile":0,"isBlock":false,"isCached":false,"isEncrypted":false,"isFile":false,"isHidden":false,"isHosted":false,"isSent":false,"lastSyncedDate":"1970-01-01T00:00:00.000Z","length":0,"name":"none.png","siteID":-1,"statusID":5001,"tenantFileSrcId":0,"useTimestamp":true}' },
                { name: "commentGrp_2105687934", value: '["extras.listeDesordres.desordre_822129563.technique_2111129646.photos_581899708.commentGrp_2105687934.commentTitle_1475352500","extras.listeDesordres.desordre_822129563.technique_2111129646.photos_581899708.commentGrp_2105687934.comment_537413025"]' },
                { name: "commentTitle_1475352500", value: '{"id":2,"tag":"Mise sous pression manométrique des AEP","value":"2"}' },
                { name: "comment_537413025", value: 'Mise sous pression manométrique des AEP\n\ntest automatique' },

                { name: "technique_121677086", value: '["extras.listeDesordres.desordre_822129563.technique_121677086.titreTech_1214218306","extras.listeDesordres.desordre_822129563.technique_121677086.commentaireTech_229572788","extras.listeDesordres.desordre_822129563.technique_121677086.photos_46465110"]' },
                { name: "titreTech_1214218306", value: '{"id":5,"tag":"Passage caméra endoscopique","value":"5"}' },
                { name: "commentaireTech_229572788", value: 't2' },
                { name: "photos_46465110", value: '["extras.listeDesordres.desordre_822129563.technique_121677086.photos_46465110.photoTech_1128884083","extras.listeDesordres.desordre_822129563.technique_121677086.photos_46465110.photoTech2_1391314945","extras.listeDesordres.desordre_822129563.technique_121677086.photos_46465110.commentGrp_327823106"]' },
                { name: "photoTech_1128884083", value: '{"bindID":0,"dSysMod":"1970-01-01T00:00:00.000Z","fileTypeID":0,"idFile":0,"isBlock":false,"isCached":false,"isEncrypted":false,"isFile":false,"isHidden":false,"isHosted":false,"isSent":false,"lastSyncedDate":"1970-01-01T00:00:00.000Z","length":0,"name":"none.png","siteID":-1,"statusID":5001,"tenantFileSrcId":0,"useTimestamp":true}' },
                { name: "photoTech2_1391314945", value: '{"bindID":0,"dSysMod":"1970-01-01T00:00:00.000Z","fileTypeID":0,"idFile":0,"isBlock":false,"isCached":false,"isEncrypted":false,"isFile":false,"isHidden":false,"isHosted":false,"isSent":false,"lastSyncedDate":"1970-01-01T00:00:00.000Z","length":0,"name":"none.png","siteID":-1,"statusID":5001,"tenantFileSrcId":0,"useTimestamp":true}' },
                { name: "commentGrp_327823106", value: '["extras.listeDesordres.desordre_822129563.technique_121677086.photos_46465110.commentGrp_327823106.commentTitle_236557746","extras.listeDesordres.desordre_822129563.technique_121677086.photos_46465110.commentGrp_327823106.comment_1133642764"]' },
                { name: "commentTitle_236557746", value: '{"id":6,"tag":"Passage caméra","value":"6"}' },
                { name: "comment_1133642764", value: 'Passage caméra' },
            ]
        }
    };

    function initModal() {

        //Rapport >> Sélection de services pour activer la sélection des modèles
        //DT_RPTS / REPORT / DLG_REPORT / DLG_ITV / DT_CTCS / CONTACTS / DLG_CONTACT
        //LST_REPORT / DTL_REPORT / DLG_DTL_REPORT ( / DTL_REPORT_1 / DTL_REPORT_2 )

        //Seulement la sélection de modèles REPORTS
        //Sélection du secteur d'activité >> Agence Modèle (faire un json local >> 1 Déménagement / 2 Service à la personne / 3 Recherche de fuite / etc...)
        //Sélection des services via un TreeView (prévoir un input pour modifier le nom directement)

        Swal.fire({
            title: "Chargement en cours...",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        commonFunc.getMethod("../api/site/GetSite", { id: parentContext.user ? parentContext.user.groupSId : -1 }).then((responseSite) => {
            if (responseSite.data.isSuccess) {
                setSite(responseSite.data.result);

                commonFunc.getMethod("../api/site/GetSiteServices", { withInactive: true }).then((response) => {
                    if (response.data.isSuccess) {
                        setServices(response.data.result.filter(svc => svc.idService > 0 && !svc.isContract && svc.categ === "ACT" && svc.businessSector !== "MOBILE" && svc.reportCategoryID > 0));

                        /*commonFunc.getMethod("../api/data/GetAllModels", { filter: "report|employee" }).then((responseModels) => {
                            var data = responseModels.data;
                            if (data && data.isSuccess) {
                                var modelsMix = data.result.map(model => model.tag);
                                setModels(modelsMix);
                                console.debug(modelsMix);
                            }
                        });*/
                        /*commonFunc.getMethod("../api/report/GetReportModels", { id: -1 }).then((responseModels) => {
                            Swal.close();

                            var data = responseModels.data;
                            if (data && data.isSuccess) {
                                console.debug(data.result);
                                var modelsReport = data.result.models;
                                setModels(modelsReport);
                            }
                        });*/
                        commonFunc.getMethod("../api/site/GetSiteModelsList", { id: -1, extId: "HOME" }).then((responseSiteModels) => {
                            var data = responseSiteModels.data;
                            if (data && data.isSuccess) {
                                var modelsSite = data.result;
                                modelsSite.forEach((model) => { model.entity = "SITE" });

                                commonFunc.getMethod("../api/report/GetReportModels", { id: -1 }).then((responseModels) => {

                                    var data = responseModels.data;
                                    if (data && data.isSuccess) {
                                        console.debug(data.result);
                                        var modelsReport = data.result.models;
                                        modelsReport.forEach((model) => { model.entity = "REPORT" });
                                        var modelsMix = modelsSite.concat(modelsReport);

                                        commonFunc.getMethod("../api/employee/GetEmployeeModels", { id: -1 }).then((responseEmpModels) => {
                                            Swal.close();

                                            var data = responseEmpModels.data;
                                            if (data && data.isSuccess) {
                                                console.debug(data.result);
                                                var modelsEmployee = data.result.models;
                                                modelsEmployee.forEach((model) => { model.entity = "EMPLOYEE" });

                                                modelsMix = modelsMix.concat(modelsEmployee);
                                                setModels(modelsMix);

                                                var newHomeModel;
                                                var homeModels = modelsMix?.filter((model) => model.extID === "HOME");
                                                if (homeModels?.length) {
                                                    newHomeModel = JSON.parse(homeModels[0].value);
                                                    setHomeModel(newHomeModel);
                                                }

                                            } else {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: "Erreur",
                                                    html: "Echec de récupération des modèles employées :<br>" + responseEmpModels.data.errorMessage
                                                });
                                            }
                                        });
                                    } else {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Erreur",
                                            html: "Echec de récupération des modèles rapport :<br>" + responseModels.data.errorMessage
                                        });
                                    }
                                });
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Erreur",
                                    html: "Echec de récupération des modèles agence :<br>" + responseSiteModels.data.errorMessage
                                });
                            }
                        });

                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Erreur",
                            html: "Echec de récupération des services :<br>" + response.data.errorMessage
                        });
                    }
                });


            } else {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    html: "Echec de récupération des informations de l'agence :<br>" + responseSite.data.errorMessage
                });
            }
        });

    }

    async function finalizeFirstStep() {
        var checkAct = Array.isArray(currActivities) ? currActivities : [{ value: currActivities }];
        if (!checkAct || checkAct.length <= 0 || !checkAct[0].value || checkAct[0].value <= 0) {
            Swal.fire({
                icon: "warning",
                title: "Attention",
                html: "Veuillez sélectionner un secteur d'activité"
            });
            setCurrActivityInvalid(true);
            //setSiteIsOpen(true); setModelsIsOpen(false); setEmployeesIsOpen(false);
            return false;
        }


        var result = {};
        //result.activity = currActivities && currActivities.length ? currActivities[0].value : -1;
        result.activity = currActivities && currActivities.length ? currActivities.map(v => v.value).join(";") : "";
        result.siteName = siteName || (site ? site.name : "");
        result.color1 = color1.replace("#", "#FF");
        result.color2 = color2.replace("#", "#FF");
        result.color3 = color3.replace("#", "#FF");
        result.color4 = color4.replace("#", "#FF");
        result.services = currServices;

        console.debug(result);

        return true;
    }

    async function finalizeSecondStep(ignoreDialog) {

        Swal.fire({
            title: parentContext.props.i18nManager.t("gal_saving"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });


        var result = {};
        //result.activity = currActivities && currActivities.length ? currActivities[0].value : -1;
        result.activity = currActivities && currActivities.length ? currActivities.map(v => v.value).join(";") : "";
        result.siteName = siteName || (site ? site.name : "");
        result.color1 = color1.replace("#", "#FF");
        result.color2 = color2.replace("#", "#FF");
        result.color3 = color3.replace("#", "#FF");
        result.color4 = color4.replace("#", "#FF");
        result.services = currServices;

        result.homeModel = currModelHome;
        result.reportModel = currModelReport;

        result.employees = employees;
        result.file = selectedFile;
        result.argumentsObj = pictureData.argumentsObj;
        result.bindPropResult = pictureData.bindPropResult;

        if (ignoreDialog) result.ignoreDialog = true;

        //var withContract = document.getElementById("withContract");
        //var useAI = document.getElementById("useAIReportCorrection");
        //var defaultAI = document.getElementById("defaultAIReportCorrection");

        var curSiteID = parentContext?.user?.groupSId || -1;
        result.siteExtras = [];
        //if (withContract) result.siteExtras.push({ idExtra: 0, siteID: curSiteID, extraSiteID: curSiteID, name: "withContract", value: withContract.checked });
        //if (useAI) result.siteExtras.push({ idExtra: 0, siteID: curSiteID, extraSiteID: curSiteID, name: "useAIReportCorrection", value: useAI.checked });
        //if (defaultAI) result.siteExtras.push({ idExtra: 0, siteID: curSiteID, extraSiteID: curSiteID, name: "defaultAIReportCorrection", value: defaultAI.checked });

        console.debug(result);


        console.debug(models);
        console.debug(currServices);

        //Gestion des modèles
        result.modelsToSave = [];
        models.forEach((model) => {
            if (model.activeModel?.cEdited) {
                if (model.activeModel.functionManager) model.value = prepareModelToSave(model.activeModel);
                else if (model.activeModel.Details) {
                    delete model.activeModel.cEdited;
                    model.value = JSON.stringify(model.activeModel);
                }
                result.modelsToSave.push(model);
            }
        });

        callback(result);
    }

    function siteAvatarUpdate(file) {
        if (file) {
            if (selectedFile) {
                URL.revokeObjectURL(selectedFile.preview);
            }
            //file.preview = URL.createObjectURL(file);
            setSelectedFile(file);
        }
    }
    function fileDel({ sysEvent, props, triggerEvent, data }) {
        if (pictureData.functionManager) pictureData.functionManager.setValue(null);
        setSelectedFile(null);
    }

    function updateActivity(activities) {
        console.debug(activities);
        //var activityServices = [...services.filter((service) => service.siteID === activity.value)]; // A TEST

        var activityServices;
        if (Array.isArray(activities)) {
            activityServices = JSON.parse(JSON.stringify(services.filter((service) => {
                var flag = false;
                activities.forEach((activity) => {
                    flag |= (activity.value === "*" || (service.businessSector === activity.value || service.businessSector.startsWith(activity.value + ";") || service.businessSector.endsWith(";" + activity.value) || service.businessSector.indexOf(";" + activity.value + ";") > 0));
                    service.isActive = flag;
                });
                return flag;
            })));
        }
        else {
            activityServices = JSON.parse(JSON.stringify(services.filter((service) => activities.value === "*" || (service.businessSector === activities.value || service.businessSector.startsWith(activities.value + ";") || service.businessSector.endsWith(";" + activities.value) || service.businessSector.indexOf(";" + activities.value + ";") > 0))));
        }


        setCurrServices(activityServices);
        setCurrActivities(activities);
        setCurrActivityInvalid(false);
    }

    function updateServiceChecked(serviceID, checked) {
        currServices.forEach((svc) => {
            if (svc.idService === serviceID) svc.isActive = checked;
        });
        setCurrServices(currServices);
        setShouldRender(!shouldRender);
    }
    function updateServiceName(serviceID, name) {
        currServices.forEach((svc) => {
            if (svc.idService === serviceID) svc.name = name;
        });
        setCurrServices(currServices);
        setShouldRender(!shouldRender);
    }
    function updateServiceColor(serviceID, color) {
        currServices.forEach((svc) => {
            if (svc.idService === serviceID) {
                svc.startColor = color;
                svc.endColor = color;
            }
        });
        setCurrServices(currServices);
        setShouldRender(!shouldRender);
    }

    function updateModel(model, groupedServices, modelHtml) {
        //TODO : Il faut qu'il n'y ait qu'un seul Template de isActive:true (1 isHtml et 1 non isHtml)

        if (groupedServices?.length) {
            groupedServices.forEach((modelSvc) => {
                if (modelSvc.templates?.length) {
                    modelSvc.templates.forEach(template => {
                        if (model.template.siteID === template.siteID) {
                            //if ((model.template.isHtml && template.isHtml) || (!model.template.isHtml && !template.isHtml)) {
                                template.isActive = (template.extID === model.template.extID);
                            //}
                        }
                    });
                    modelSvc.activeExtID = model.template.extID;
                }
            });
            showModelPreview(model, modelHtml);
            setCurrServices(currServices);
            setShouldRender(!shouldRender);
        }
        else {
            if (model.template /*&& !model.template.isActive*/) {
                var modelSvc = currServices.filter(svc => svc.idService === model.template.serviceID);
                if (modelSvc.length && modelSvc[0].templates && modelSvc[0].templates.length) {
                    modelSvc[0].templates.forEach(template => {
                        if (model.template.siteID === template.siteID) {
                            if ((model.template.isHtml && template.isHtml) || (!model.template.isHtml && !template.isHtml)) {
                                template.isActive = false;
                            }
                        }
                    });
                    model.template.isActive = true;
                    showModelPreview(model, modelHtml);
                }
                setCurrServices(currServices);
                setShouldRender(!shouldRender);
            }
        }
    }

    function updateSingleModel(keyModel) {
        if (keyModel.startsWith("HOME")) {
            setCurrModelHome(keyModel);
        }
        else {
            setCurrModelReport(keyModel);
        }
        setCurrModel({ title: keyModel });
    }

    function showModelPreview(model, modelHtml, selectModels) {
        var currActiveModel = selectModels?.filter(modelItem => modelItem.template && modelItem.template.isActive);
        if (currActiveModel?.length) {
            var jsonModels = currActiveModel.filter(model => !model.isHtml);
            if (jsonModels?.length) model = jsonModels[0];

            var htmlModels = currActiveModel.filter(model => model.isHtml);
            if (htmlModels?.length) modelHtml = htmlModels[0];
        }
        console.debug(selectModels);
        console.debug(htmlModels);

        if (modelHtml?.template?.isActive) {
            setCurrModelHtml(modelHtml);
        }
        if (model?.template?.isActive) {
            setCurrModel(model);
            setShouldRender(!shouldRender);
        }
    }

    function showDlgModelPreview(service, models) {
        if (window.modalContainer) {
            window.modalContainer.unmount();
            window.modalContainer = null;
        }

        //Traitement des informations retourné par le Dialog
        var callbackModal = function (data, isUpdate) {
            return new Promise((resolve, reject) => {
                if (data) {
                    console.debug(data);
                    //employees[Math.floor(Math.random() * 1000000000)] = data;
                    //setEmployees(employees);
                    //setShouldRender(!shouldRender);

                    //TODO

                    window.modalContainer.unmount();
                    resolve();
                }
                else {
                    window.modalContainer.unmount();
                    resolve();
                }
            });
        };

        if (models?.length) {
            window.modalContainer = createRoot(document.createElement('div'));
            window.modalContainer.render(<DlgPreviewModal parentContext={parentContext} title={"Modèle du service"} site={site} defaultSample={defaultSample} service={service} modelsList={models} callback={callbackModal}></DlgPreviewModal>);
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Configuration introuvable"
            });
        }
    }

    function addEmployee() {
        /*employees.push({ idEmployee: Math.floor(Math.random() * 1000000000), firstName: "Toto", name: "TEST" });
        setEmployees(employees);
        setShouldRender(!shouldRender);*/



        var title = "Ajout d'un employé";

        if (window.modalContainer) {
            window.modalContainer.unmount();
            window.modalContainer = null;
        }

        //Traitement des informations retourné par le Dialog
        var callbackModal = function (data, isUpdate) {
            return new Promise((resolve, reject) => {
                if (data) {
                    console.debug(data);
                    employees[Math.floor(Math.random() * 1000000000)] = data;
                    setEmployees(employees);
                    setShouldRender(!shouldRender);

                    window.modalContainer.unmount();
                    resolve();
                }
                else {
                    window.modalContainer.unmount();
                    resolve();
                }
            });
        };

        var employeeModel = models.filter((model) => model.extID === "FAST_EMPLOYEE");
        if (employeeModel && employeeModel.length) {
            window.modalContainer = createRoot(document.createElement('div'));
            window.modalContainer.render(<EmployeeModal parentContext={parentContext} employeeGenManager={employeeGenManager} title={title} configModel={JSON.parse(employeeModel[0].value)} modelsList={null} callback={callbackModal}></EmployeeModal>);
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Configuration introuvable"
            });
        }
    }

    function removeEmployee(employeeKey) {
        delete employees[employeeKey];
        setEmployees(employees);
        setShouldRender(!shouldRender);
    }

    function renderTab(tabIndex, navContent) {
        var navItemStyle = {};
        var activeStyle = {};
        if (selectedTab === tabIndex.toString()) {
            activeStyle.color = "#225072";
            activeStyle.fontWeight = "bold";
        }
        else {
            activeStyle.color = "#71757D";
        }

        return (<NavItem key={tabIndex}
            className={`flex-fill text-center`}
        >
            <NavLink
                href="#"
                className={`ctabnav nav-link mx-2 h-100 ${selectedTab === tabIndex.toString() ? "active" : ""}`} style={{ justifyItems: "center", ...navItemStyle, ...activeStyle }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    //setSelectedTab(tabIndex.toString());
                }}
            >
                {<h5
                    className={"rounded-circle mx-2 fw-bold"} style={{
                        width: "46px",
                        height: "46px",
                        lineHeight: "46px",
                        padding: 0,
                        marginBottom: "12px",
                        backgroundColor: selectedTab === tabIndex.toString() ? "#225072" : "#e9ecef",
                        color: selectedTab === tabIndex.toString() ? "white" : "#6c757d",
                        position: "relative",
                    }}>{tabIndex}</h5>}
                {navContent}
            </NavLink>
        </NavItem>);
    }


    //console.debug("render modal");


    console.debug(currServices);
    var groupedServices = Object.groupBy(currServices.sort((a, b) => {
        return a.businessSector.localeCompare(b.businessSector);
    }), (svc, index) => {
        return svc.parentID;
    });
    /*var groupedServices = [];
    if (services.length) {
        services.forEach((svc) => {
            if (svc.parentID < 0) {
                groupedServices.push(svc);
                currServices.forEach((svcAct) => {
                    if (!svc.subServices) svc.subServices = [];
                    svc.subServices.push(svcAct);
                });
            }
        });
    }*/

    console.debug(groupedServices);

    if (site) pictureData.defaultValue = site.avatar;



    return (
        <Modal isOpen={true} className={`c-preview modal-report dlg-step ${noScroll ? "modal-noscroll" : ""}`} size="xxl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex p-2 p-sm-3 pe-3" toggle={() => { callback(); }}>{title}</ModalHeader>    
            <ModalBody className="px-2 py-0" style={{ overflowX: "hidden" }}>
                <Row>
                    <Col className="pb-3" xs="12">
                        <h3 className="mb-2">{parentContext.props.i18nManager.t("homeAssistant.welcome")}</h3>
                        <p>{parentContext.props.i18nManager.t("homeAssistant.description")}</p>

                        <Nav tabs className="d-flex mb-1 ctabs-flow" style={{}}>
                            {renderTab("1", <>{parentContext.props.i18nManager.t("homeAssistant.titleSite")}</>)}
                            {renderTab("2", <>{parentContext.props.i18nManager.t("homeAssistant.titleSvc")}</>)}
                            {renderTab("3", <>{parentContext.props.i18nManager.t("homeAssistant.titleAppMobile")}</>)}
                            {renderTab("4", <>{parentContext.props.i18nManager.t("homeAssistant.titleEmp")}</>)}
                        </Nav>

                        <Card className={`widget dash site-widget p-3 mb-0 ${selectedTab === "1" ? "" : "d-none"}`}>
                            <h5 className="title">{parentContext.props.i18nManager.t("homeAssistant.titleSite")}</h5>
                            <div className="widget-tools collapse-tool" onClick={() => { setSiteIsOpen(!siteIsOpen) }} style={{ cursor: "pointer" }}>
                                <i className={`fa ${siteIsOpen ? "fa-chevron-up" : "fa-chevron-down"} fa-lg mt-3`}></i>
                            </div>
                            <Row className={`${siteIsOpen ? "" : "d-none"}`}>
                                <Col xs="12" sm="4" lg="2">
                                    <h6>{parentContext.props.i18nManager.t("homeAssistant.siteAvatarLabel")}</h6>
                                    <div style={{ width: "fit-content" }}>
                                        {site ? <PictureFrag data={pictureData} formManager={{ register: () => { return { ref: siteAvatarBtn }; }, setValue: () => { } }} modelFctManager={{ getRgbaFromHex: getRgbaFromHex, convertWidthToGrid: convertWidthToGrid, extFileCb: siteAvatarUpdate, prepareMergedDesign: (data, design) => { return design } }} bindPropResult="" parentDisabled={false}
                                            srcFileManager={{ className: "siteAvatar", showContextMenu: showContextMenu, hideAllMenu: hideAllMenu }} /> : ""}
                                    </div>
                                </Col>

                                <Col xs="12" sm="8" lg="4">
                                    <h6>{parentContext.props.i18nManager.t("homeAssistant.siteNameLabel")}</h6>
                                    <Input type="text" className="mb-3" autoComplete="off" aria-autocomplete="none" defaultValue={(site ? site.name : "")} onChange={(event) => { setSiteName(event.target.value); }} />

                                </Col>

                                <Col xs="12" lg="6">
                                    <h6>{parentContext.props.i18nManager.t("homeAssistant.activitySelection")}</h6>
                                    <Select
                                        isMulti
                                        name="activitySelection"
                                        defaultValue={currActivities}
                                        options={activities}
                                        className={`basic-multi-select mb-3 ${!currActivityInvalid ? "" : "is-invalid"}`}
                                        classNamePrefix="select"
                                        placeholder={parentContext.props.i18nManager.t("homeAssistant.activityShouldSelect")}
                                        onChange={(value) => {
                                            updateActivity(value);
                                        }}
                                    />

                                </Col>

                                <Col xs="12" className="d-none">
                                    <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                                        <Label check for={"withContract"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                                            <div className={`d-inline-block`}>
                                                <Input type="checkbox" id={"withContract"} defaultChecked={false} />
                                                <span className={`form-check-sign`} />
                                                <div className={`d-inline-block ms-4`}>Récupération Salarié/Client par contrat</div>
                                            </div>
                                        </Label>
                                    </div>
                                </Col>
                                <Col xs="12" className="d-none">
                                    <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                                        <Label check for={"useAIReportCorrection"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                                            <div className={`d-inline-block`}>
                                                <Input type="checkbox" id={"useAIReportCorrection"} defaultChecked={true} />
                                                <span className={`form-check-sign`} />
                                                <div className={`d-inline-block ms-4`}>Activer l'option "Correction des rapports par IA"</div>
                                            </div>
                                        </Label>
                                    </div>
                                    <div className={`form-check form-check-inline fcheck-sm mt-2`}>
                                        <Label check for={"defaultAIReportCorrection"} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                                            <div className={`d-inline-block`}>
                                                <Input type="checkbox" id={"defaultAIReportCorrection"} defaultChecked={false} />
                                                <span className={`form-check-sign`} />
                                                <div className={`d-inline-block ms-4`}>"Correction des rapports par IA" par défaut</div>
                                            </div>
                                        </Label>
                                    </div>
                                </Col>

                                <Col xs="12">
                                    <Button className="btn-round btn-sm float-end" color="primary" onClick={() => {
                                        var checkAct = Array.isArray(currActivities) ? currActivities : [{ value: currActivities }];
                                        if (!checkAct || checkAct.length <= 0 || !checkAct[0].value || checkAct[0].value <= 0) {
                                            Swal.fire({
                                                icon: "warning",
                                                title: "Attention",
                                                html: parentContext.props.i18nManager.t("homeAssistant.activityShouldSelect")
                                            });
                                            setCurrActivityInvalid(true);
                                            //setSiteIsOpen(true); setModelsIsOpen(false); setEmployeesIsOpen(false);
                                            return false;
                                        }

                                        //setSiteIsOpen(false); setModelsIsOpen(true); setEmployeesIsOpen(false);
                                        setSelectedTab("2");
                                    }}>{parentContext.props.i18nManager.t("gal_next")}</Button>
                                </Col>

                            </Row>
                        </Card>


                        <Card className={`widget dash p-3 mb-0 ${selectedTab === "2" ? "" : "d-none"}`}>
                            <h5 className="title">{parentContext.props.i18nManager.t("homeAssistant.titleSvc")}</h5>
                            <Row className={``}>
                                <Row className="w-100 pe-0">
                                    <Col sm="12" md="12" xl="12" className="service-container p-0 px-xl-2" style={{ overflowY: "auto", overflowX: "hidden" }}>
                                    {(groupedServices && Object.keys(groupedServices).length) ? Object.keys(groupedServices).map((parentSvcKey, index) => {
                                        var childServices = groupedServices[parentSvcKey];
                                        var parentSvc = childServices[0].parent;

                                        return <div key={"parentSvc-" + parentSvcKey} className="selectmodel-parentsvc">
                                            {parentSvc ? <Label className="fw-bold mt-2 selectmodel-parentlabel">{parentSvc.name}</Label> : ""}
                                            {childServices.map((service, index) => {
                                                var modelsFiltered = service.templates?.length > 0 ? models.filter((model) => {
                                                    return service.templates.filter((template) => {
                                                        if (template.extID === model.extID) model.template = template;
                                                        return template.extID === model.extID;
                                                    }).length > 0;
                                                }) : [];

                                                console.debug(modelsFiltered);

                                                //var htmlModels = modelsFiltered.filter(model => model.isHtml).map((model, indexModel) => { return { value: model.idModel, label: model.title } });
                                                var jsonModels = modelsFiltered.filter(model => !model.isHtml).map((model, indexModel) => { return { value: model.idModel, label: model.title } });

                                                var checked = service.isActive;

                                                return <div key={"svc" + service.idService}>

                                                    <div className={`form-check form-check-inline fcheck-sm me-2`}>
                                                        <Label check for={"modalSelection-" + parentSvcKey + index} className={`d-inline-block px-0`} style={{ minWidth: "16px" }}>
                                                            <div className={`d-inline-block`}>
                                                                <Input type="checkbox" id={"modalSelection-" + parentSvcKey + index} checked={checked} onChange={(e) => { updateServiceChecked(service.idService, e.target.checked); }} />
                                                                <span className={`form-check-sign`} />
                                                            </div>
                                                        </Label>
                                                    </div>
                                                    <Input type="text" className={`input-svc w-auto d-inline-block ${!commonFunc.isBlank(service.name) ? "" : "is-invalid"}`} bsSize={"sm"} autoComplete="off" aria-autocomplete="none" defaultValue={service.name} onChange={(event) => { updateServiceName(service.idService, event.target.value); }} />
                                                    <Input type="color" className="d-inline-block" autoComplete="off" aria-autocomplete="none" defaultValue={service.startColor} onChange={(event) => { updateServiceColor(service.idService, event.target.value); }} style={{ width: "50px" }} />

                                                    {jsonModels.length ? <Button className="btn-icon" size="sm" color="primary" onClick={() => { showDlgModelPreview(service, modelsFiltered); }}><i className="fa fa-eye"></i></Button> : ""}
                                                </div>;
                                            })}
                                        </div>;
                                    }) : "Aucun services paramètrable"}
                                    </Col>
                                </Row>

                                <Col xs="12">
                                    <Button className="btn-round btn-sm float-start" color="secondary" onClick={() => {
                                        setSelectedTab("1");
                                    }}>{parentContext.props.i18nManager.t("gal_previous")}</Button>
                                    <Button className="btn-round btn-sm float-end" color="primary" onClick={() => {
                                        var checkSvc = Array.isArray(currServices) ? currServices : [];
                                        checkSvc = checkSvc.filter(svc => svc.isActive && svc.parentID === 1);
                                        if (!checkSvc || checkSvc.length <= 0) {
                                            Swal.fire({
                                                icon: "warning",
                                                title: "Attention",
                                                html: parentContext.props.i18nManager.t("homeAssistant.svcShouldSelect")
                                            });
                                            //setSiteIsOpen(true); setModelsIsOpen(false); setEmployeesIsOpen(false);
                                            return false;
                                        }
                                        //setSiteIsOpen(false); setModelsIsOpen(false); setEmployeesIsOpen(true);
                                        //setShowFinalize(true);
                                        setSelectedTab("3");
                                    }}>{parentContext.props.i18nManager.t("gal_next")}</Button>
                                </Col>
                            </Row>
                        </Card>



                        <Card className={`widget dash p-3 mb-0 ${selectedTab === "3" ? "" : "d-none"}`}>
                            <h5 className="title">{parentContext.props.i18nManager.t("homeAssistant.titleAppMobile")}</h5>
                            <div className="widget-tools collapse-tool" onClick={() => { setModelsIsOpen(!modelsIsOpen) }} style={{ cursor: "pointer" }}>
                                <i className={`fa ${modelsIsOpen ? "fa-chevron-up" : "fa-chevron-down"} fa-lg mt-3`}></i>
                            </div>
                            <Row className={`${modelsIsOpen ? "" : "d-none"}`}>

                                <Col sm="12" md="12" xl="6">
                                    <h6>{parentContext.props.i18nManager.t("homeAssistant.appColors")}</h6>
                                    <div className="d-inline-block me-3"><Label className="d-inline-block me-2">{parentContext.props.i18nManager.t("homeAssistant.appColor1")}</Label><Input type="color" className="d-inline-block" autoComplete="off" aria-autocomplete="none" defaultValue={color1} onChange={(event) => {
                                        setColor1(event.target.value);
                                        var generateModel = modalGenManager.current;
                                        if (generateModel?.updateColor1) {
                                            generateModel.updateColor1(event.target.value);
                                        }
                                    }} style={{ width: "50px" }} /></div>
                                    <div className="d-inline-block me-3"><Label className="d-inline-block me-2">{parentContext.props.i18nManager.t("homeAssistant.appColor2")}</Label><Input type="color" className="d-inline-block" autoComplete="off" aria-autocomplete="none" defaultValue={color2} onChange={(event) => {
                                        setColor2(event.target.value);
                                        var generateModel = modalGenManager.current;
                                        if (generateModel?.updateColor2) {
                                            generateModel.updateColor2(event.target.value);
                                        }
                                    }} style={{ width: "50px" }} /></div>
                                    <div className="d-inline-block me-3"><Label className="d-inline-block me-2">{parentContext.props.i18nManager.t("homeAssistant.appColor3")}</Label><Input type="color" className="d-inline-block" autoComplete="off" aria-autocomplete="none" defaultValue={color3} onChange={(event) => {
                                        setColor3(event.target.value);
                                        var generateModel = modalGenManager.current;
                                        if (generateModel?.updateColor3) {
                                            generateModel.updateColor3(event.target.value);
                                        }
                                    }} style={{ width: "50px" }} /></div>
                                    <div className="d-inline-block me-3"><Label className="d-inline-block me-2">{parentContext.props.i18nManager.t("homeAssistant.appColor4")}</Label><Input type="color" className="d-inline-block" autoComplete="off" aria-autocomplete="none" defaultValue={color4} onChange={(event) => {
                                        setColor4(event.target.value);
                                        var generateModel = modalGenManager.current;
                                        if (generateModel?.updateColor4) {
                                            generateModel.updateColor4(event.target.value);
                                        }
                                    }} style={{ width: "50px" }} /></div>


                                    <div className="d-none">
                                        <h6>Sélection &gt; Accueil Mobile</h6>
                                        <Row>
                                            <Col>
                                                <Card className={`model-selection widget dash p-3 ${currModelHome === "HOME_1" ? "selected" : ""}`} onClick={() => { updateSingleModel("HOME_1"); }}>
                                                    <h6 className="title">Home 1</h6>
                                                    <Row>


                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card className={`model-selection widget dash p-3 ${currModelHome === "HOME_2" ? "selected" : ""}`} onClick={() => { updateSingleModel("HOME_2"); }}>
                                                    <h6 className="title">Home 2</h6>
                                                    <Row>


                                                    </Row>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="d-none">
                                        <h6>Sélection &gt; Modèle Rapport</h6>
                                        <Row>
                                            <Col>
                                                <Card className={`model-selection widget dash p-3 ${currModelReport === "DTL_REPORT_1" ? "selected" : ""}`} onClick={() => { updateSingleModel("DTL_REPORT_1"); }}>
                                                    <h6 className="title">Rapport 1</h6>
                                                    <Row>


                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card className={`model-selection widget dash p-3 ${currModelReport === "DTL_REPORT_2" ? "selected" : ""}`} onClick={() => { updateSingleModel("DTL_REPORT_2"); }}>
                                                    <h6 className="title">Rapport 2</h6>
                                                    <Row>


                                                    </Row>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Form>
                                        <a href="https://play.google.com/store/apps/details?id=com.softena.oskalacore"><img src="https://www.oskala.com/assets/fr_badge_web_generic.png" width="128" className="img-fluid" alt="google_play" /></a>
                                        <small className="text-muted d-none"><br />Google Play et le logo Google Play sont des marques de Google LLC.</small>
                                    </Form>

                                </Col>

                                <Col sm="12" md="12" xl="6" style={{ justifyItems: "center", textAlign: "center" }}>
                                    {homeModel ? <><div style={{ width: "260px", height: "512px", textAlign: "initial" }}><div className={`zoom-container zoom-${zoomValue}`} style={{ zoom: 0.3, overflow: "hidden", backgroundImage: `url(${require("assets/img/res/smartphone-frame.png")})`, backgroundSize: "cover", padding: "37px", paddingTop: "138px", paddingLeft: "32px", height: "100%" }}>
                                        <AConfigureModel parentProps={{ type: "site", dataCfg: parentContext.props.dataCfg }} ref={modalGenManager} noButtons showActionBar exceptionConfiguration
                                            onSubmit={(data, isUpdate) => { return callback(data, isUpdate) }} appProps={parentContext.props} checkRights={parentContext.props.checkRights} getRoutes={parentContext.props.getRoutes} configModel={homeModel} modelsList={modelsList} loadedData={null} />
                                    </div></div>
                                        <ButtonGroup className="align-items-center">
                                            <Button className="btn-simple btn-icon magnify" color="dark" size="sm" onClick={() => { if (zoomValue > 0) setZoomValue(zoomValue - 1) }}><i className="fa fa-magnifying-glass-minus"></i></Button>
                                            <span className="mx-2">{(100 + zoomValue * 25) + "%"}</span>
                                            <Button className="btn-simple btn-icon magnify" color="dark" size="sm" onClick={() => { if (zoomValue < 3) setZoomValue(zoomValue + 1) }}><i className="fa fa-magnifying-glass-plus"></i></Button>
                                        </ButtonGroup>
                                    </> : ""}
                                </Col>

                                <Col xs="12">
                                    <Button className="btn-round btn-sm float-start" color="secondary" onClick={() => {
                                        setSelectedTab("2");
                                    }}>{parentContext.props.i18nManager.t("gal_previous")}</Button>
                                    <Button className="btn-round btn-sm float-end" color="primary" onClick={() => {
                                        //setSiteIsOpen(false); setModelsIsOpen(false); setEmployeesIsOpen(true);
                                        setShowFinalize(true);
                                        setSelectedTab("4");
                                    }}>{parentContext.props.i18nManager.t("gal_next")}</Button>
                                </Col>
                            </Row>
                        </Card>


                        <Card className={`widget dash p-3 mb-0 ${selectedTab === "4" ? "" : "d-none"}`}>
                            <h5 className="title">{parentContext.props.i18nManager.t("homeAssistant.titleEmp")}</h5>
                            <div className="widget-tools collapse-tool" onClick={() => { setEmployeesIsOpen(!employeesIsOpen) }} style={{ cursor: "pointer" }}>
                                <i className={`fa ${employeesIsOpen ? "fa-chevron-up" : "fa-chevron-down"} fa-lg mt-3`}></i>
                            </div>
                            <Row className={`${employeesIsOpen ? "" : "d-none"}`}>

                                <h6>{parentContext.props.i18nManager.t("homeAssistant.titleEmp")}</h6>

                                <Button className="ms-3 px-3 w-auto" color="primary" onClick={() => {
                                    addEmployee();
                                }}><i className="fa fa-plus"></i>{parentContext.props.i18nManager.t("gal_add")}</Button>
                                <Row className="w-100">
                                    {Object.keys(employees).map((employeeKey, index) => {
                                        var employee = employees[employeeKey];
                                        return (<div key={"emp" + index} style={{ width: "350px" }}>
                                            <Card className={`widget dash`}>
                                                <CardHeader className="pt-0">
                                                    <CardTitle tag="h6" className="mt-3">{employee.name + " " + employee.firstName}</CardTitle>
                                                    <div className="widget-tools collapse-tool">
                                                        {employee.email}
                                                    </div>
                                                    <div className='borderTheme'></div>
                                                </CardHeader>
                                                <CardBody>
                                                    <Button className="btn-icon" size="sm" color="danger" onClick={() => {
                                                        removeEmployee(employeeKey);
                                                    }}><i className="fa fa-trash"></i></Button>
                                                </CardBody>
                                            </Card>
                                        </div>);
                                    })}
                                </Row>

                                <Col xs="12">
                                    <Button className="btn-round btn-sm float-start" color="secondary" onClick={() => {
                                        setSelectedTab("3");
                                    }}>{parentContext.props.i18nManager.t("gal_previous")}</Button>
                                </Col>
                            </Row>
                        </Card>

                    </Col>
                </Row>
                <Menu id={`contextMenu-siteAvatar`} onVisibilityChange={() => {/*console.debug(document.querySelector(".contexify") ? document.querySelector(".contexify").outerHTML : "")*/ }}>
                    <Item data="genFileDel" onClick={fileDel.bind(this)}>
                        <i className="fa fa-times" aria-hidden="true"></i>&nbsp;{parentContext.props.i18nManager.t("gal_remove")}
                    </Item>
                </Menu>

            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <div style={{ flex: "auto" }}><Button className="btn-simple px-3 f-start" color="dark" onClick={() => { finalizeSecondStep(true); }}><i className="fa fa-eye-slash"></i>{parentContext.props.i18nManager.t("homeAssistant.notInterested")}</Button></div>
                {
                    showFinalize ? <Button className="px-3" color="success" onClick={() => {
                        finalizeFirstStep().then(result => {
                            var flag = result;
                            console.debug(flag);
                            if (flag) finalizeSecondStep();
                        });
                    }}><i className="fa fa-save"></i>{parentContext.props.i18nManager.t("gal_finalize")}</Button> : ""
                }
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{parentContext.props.i18nManager.t("gal_cancel")}</Button>
            </ModalFooter>
        </Modal>
    );
}


//Création d'un "function component" pour gérer l'affichage du Dialog
//props correspond aux attributs fournies lors de la déclaration de ReportModal
function EmployeeModal({ title, parentContext, employeeGenManager, noScroll, configModel, modelsList, dataEmployee, callback }) {
    React.useEffect(() => {
        //console.debug("mount");

        //TODO : Check différence draft/ManualReport

        //if (parentContext.props.dataCfg && parentContext.props.dataCfg.dlgSup_enabledMClient) initClientList(null, 0);//TODO
        initEmployeeModal();
    }, []);



    function initEmployeeModal() {

    }

    //console.debug("render modal");

    configModel = JSON.parse(JSON.stringify(configModel));

    return (
        <Modal isOpen={true} className={`modal-report ${noScroll ? "modal-noscroll" : ""}`} size="xl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <AGenerateModel parentProps={{ type: "employee", dataCfg: parentContext.props.dataCfg }} ref={employeeGenManager} noButtons
                    onSubmit={(data, isUpdate) => { return callback(data, isUpdate) }} appProps={parentContext.props} checkRights={parentContext.props.checkRights} getRoutes={parentContext.props.getRoutes} configModel={configModel} modelsList={modelsList} loadedData={dataEmployee} />

            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {
                    dataEmployee ? <Button className="px-3" color="success" onClick={() => {
                        var generateModel = employeeGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm(true);
                        }
                    }}><i className="fa fa-edit"></i>Modifier</Button> : <Button className="px-3" color="success" onClick={() => {
                            var generateModel = employeeGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm();
                        }
                    }}><i className="fa fa-plus"></i>Ajouter</Button>
                }
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>Annuler</Button>
            </ModalFooter>
        </Modal>
    );
}

function DlgPreviewModal({ title, parentContext, noScroll, site, defaultSample, service, modelsList, callback }) {
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? parentContext.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

    var modelsFiltered = service.templates?.length > 0 ? modelsList.filter((model) => {
        return service.templates.filter((template) => {
            if (template.extID === model.extID) model.template = template;
            return template.extID === model.extID;
        }).length > 0;
    }) : [];
    service.models = modelsFiltered;

    React.useEffect(() => {
        //console.debug("mount");
        showModelPreview(null, null, modelsFiltered);
    }, []);

    const [shouldRender, setShouldRender] = React.useState(false);
    const [currModel, setCurrModel] = React.useState(null);
    const [currModelHtml, setCurrModelHtml] = React.useState(null);

    const [zoomValue, setZoomValue] = React.useState(0);

    const reportGenManager = React.useRef();
    const reportGenHtmlManager = React.useRef();
    
    function updateModel(model, groupedServices, modelHtml) {
        //TODO : Il faut qu'il n'y ait qu'un seul Template de isActive:true (1 isHtml et 1 non isHtml)

        if (groupedServices?.length) {
            groupedServices.forEach((modelSvc) => {
                if (modelSvc.templates?.length) {
                    modelSvc.templates.forEach(template => {
                        if (model.template.siteID === template.siteID) {
                            //if ((model.template.isHtml && template.isHtml) || (!model.template.isHtml && !template.isHtml)) {
                                template.isActive = (template.extID === model.template.extID);
                            //}
                        }
                    });
                    modelSvc.activeExtID = model.template.extID;
                }
            });
            showModelPreview(model, modelHtml);
            setShouldRender(!shouldRender);
        }
        else {
            if (model.template /*&& !model.template.isActive*/) {
                service.templates.forEach(template => {
                    if (model.template.siteID === template.siteID) {
                        if ((model.template.isHtml && template.isHtml) || (!model.template.isHtml && !template.isHtml)) {
                            template.isActive = false;
                        }
                    }
                });
                model.template.isActive = true;
                showModelPreview(model, modelHtml);

                setShouldRender(!shouldRender);
            }
        }
    }
    function showModelPreview(model, modelHtml, selectModels) {
        var currActiveModel = selectModels?.filter(modelItem => modelItem.template && modelItem.template.isActive);
        if (currActiveModel?.length) {
            var jsonModels = currActiveModel.filter(model => !model.isHtml);
            if (jsonModels?.length) model = jsonModels[0];

            var htmlModels = currActiveModel.filter(model => model.isHtml);
            if (htmlModels?.length) modelHtml = htmlModels[0];
        }
        console.debug(selectModels);
        console.debug(htmlModels);

        if (modelHtml?.template?.isActive) {
            setCurrModelHtml(modelHtml);
        }
        if (model?.template?.isActive) {
            setCurrModel(model);
            setShouldRender(!shouldRender);
        }
    }

    //console.debug("render modal");

    var svcObj = {};
    console.debug("CHECK SVC");
    console.debug(service.templates);
    var keyTemplates = service.templates.sort((templateA, templateB) => templateA.extID.localeCompare(templateB.extID)).map((template) => {
        return (template.isActive && template.siteID === site.idSite) ? template.extID : null;
    }).filter(template => template !== null);

    if (keyTemplates?.length) {
        if (!svcObj[keyTemplates.join(";")]) svcObj[keyTemplates.join(";")] = [];
        svcObj[keyTemplates.join(";")].push(service);
        //return true;
    }
    else {
        //return false;
    }
    console.debug(svcObj);

    return (
        <Modal isOpen={true} className={`c-preview modal-report ${noScroll ? "modal-noscroll" : ""}`} size="xl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex p-2 p-sm-3 pe-3" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <Col xs="12">
                    <h6>{parentContext.props.i18nManager.t("homeAssistant.appModels")}</h6>
                    {parentContext.props.i18nManager.t("homeAssistant.appModelsDesc")}
                </Col>

                <Col sm="12" md="12" xl="12" className="px-xl-2" style={{ maxHeight: "600px", overflowY: "auto", overflowX: "hidden" }}>
                    {Object.keys(svcObj).map((key) => {
                        var svcFiltered = svcObj[key];
                        var modelsFiltered = svcFiltered[0].models;

                        console.debug(modelsFiltered);

                        //var htmlModels = modelsFiltered.filter(model => model.isHtml).map((model, indexModel) => { return { value: model.idModel, label: model.title } });
                        var activeModel;
                        var jsonModels = modelsFiltered.filter(model => {
                            if (!model.isHtml && model.isActive && svcFiltered[0].activeExtID === model.extID) activeModel = model;
                            return !model.isHtml;
                        });
                        if (!activeModel) activeModel = jsonModels[0];

                        var activeModelCfg = activeModel ? (activeModel.activeModel || JSON.parse(activeModel.value)) : null;
                        if (activeModel) activeModel.activeModel = activeModelCfg;

                        return <div key={"grp" + key}>
                            {(/*htmlModels.length || */jsonModels.length) ? <div className="w-100">
                                <>
                                    {jsonModels.length ? <div className="d-none2">
                                        <Row>
                                            {jsonModels.map((model, indexModel) => {
                                                return <Col>
                                                    <Card className={`model-selection widget dash p-3 ${model.idModel === activeModel.idModel ? "selected" : ""}`} onClick={() => {
                                                        var selectedModel = modelsFiltered.filter(modelOpt => !modelOpt.isHtml && modelOpt.idModel === model.idModel);
                                                        var selectedModelHtml = modelsFiltered.filter(modelOpt => modelOpt.isHtml && modelOpt.extID === model.extID);
                                                        if (selectedModel?.length) updateModel(selectedModel[0], svcFiltered, selectedModelHtml?.length ? selectedModelHtml[0] : null);
                                                    }}>
                                                        <h6 className="title">{model.title}</h6>
                                                        <Row>
                                                            <Button className="btn-icon" size="sm" color="primary" style={{ position: "absolute", bottom: "0", right: "10px" }}><i className="fa fa-eye"></i></Button>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>
                                    </div> : ""}
                                    {activeModelCfg?.modalOptions && Object.keys(activeModelCfg.modalOptions)?.length ? <div>{
                                        Object.keys(activeModelCfg.modalOptions).map((opt) => {
                                            var modalOpt = activeModelCfg.modalOptions[opt];
                                            return <FormGroup key={activeModel.extID + opt} check className='text-start fcheck-sm ms-3'>
                                                <Label check>
                                                    <Input defaultChecked={modalOpt.value} type="checkbox" onChange={(event) => {
                                                        if (activeModel.extID === currModel.extID) {
                                                            var generateModel = reportGenManager.current;
                                                            if (generateModel?.manageModelOptions) {
                                                                generateModel.manageModelOptions(opt, modalOpt, event);

                                                                modalOpt.value = event.target.checked;
                                                            }
                                                            var generateModelHtml = reportGenHtmlManager.current;
                                                            if (generateModelHtml?.manageModelOptions) {
                                                                generateModelHtml.manageModelOptions(opt, modalOpt, event);

                                                                //modalOpt.value = event.target.checked;
                                                            }
                                                        }
                                                        else {
                                                            showModelPreview(null, null, modelsFiltered);
                                                            setTimeout(() => {
                                                                var generateModel = reportGenManager.current;
                                                                if (generateModel?.manageModelOptions) {
                                                                    generateModel.manageModelOptions(opt, modalOpt, event);

                                                                    modalOpt.value = event.target.checked;
                                                                }
                                                                var generateModelHtml = reportGenHtmlManager.current;
                                                                if (generateModelHtml?.manageModelOptions) {
                                                                    generateModelHtml.manageModelOptions(opt, modalOpt, event);

                                                                    //modalOpt.value = event.target.checked;
                                                                }
                                                            }, 1000);
                                                        }
                                                        var modelCfg = JSON.parse(currModel.value);
                                                        console.debug(modelCfg);
                                                    }} />
                                                    <span className="form-check-sign" />
                                                    {altT(modalOpt.targetValue)}
                                                </Label>
                                            </FormGroup>;
                                        })
                                    }</div> : ""}
                                    <hr />
                                </>
                            </div> : ""}
                        </div>;
                    })}
                </Col>
                {currModel ? (() => {
                    var modelCfg = currModel.activeModel || JSON.parse(currModel.value);
                    currModel.activeModel = modelCfg;

                    var modelCfgHtml = currModelHtml.activeModel || JSON.parse(currModelHtml.value);
                    currModelHtml.activeModel = modelCfgHtml;

                    return (<Col sm="12" md="12" xl="12" className="m-auto" style={{ justifyItems: "center", textAlign: "center" }}>
                        <h6>{currModel.title}</h6>
                        <p>{(() => {
                            var descKey = "homeAssistant.currModelDesc." + currModel.extID;
                            return parentContext.props.i18nManager.t(descKey) !== descKey ? parentContext.props.i18nManager.t(descKey) : "";
                        })()}</p>

                        {""/*<div style={{ width: "260px", height: "512px", textAlign: "initial" }}><div className={`zoom-container zoom-${zoomValue}`} style={{ zoom: 0.3, overflow: "hidden", backgroundImage: `url(${require("assets/img/res/smartphone-frame.png")})`, backgroundSize: "cover", padding: "37px", paddingTop: "138px", paddingLeft: "32px", height: "100%" }}>*/}
                        <div className="jsonModel editor-model" style={{ position: "relative" }}>
                            <img className="invisible w-100" src={require("assets/img/res/tablet-frame.png")} style={{ maxWidth: "890px" }} />
                            <div className={`alt-display-pic zoom-${zoomValue}`} style={{ backgroundImage: `url(${require("assets/img/res/tablet-frame.png")})`, textAlign: "initial" }}>
                                <AConfigureModel key={currModel.idModel + currModel.title} parentProps={{ type: "site", dataCfg: parentContext.props.dataCfg }} ref={reportGenManager} noButtons showActionBar exceptionConfiguration forcedDisabled
                                    onSubmit={(data, isUpdate) => { return callback(data, isUpdate) }} appProps={parentContext.props} checkRights={parentContext.props.checkRights} getRoutes={parentContext.props.getRoutes} configModel={modelCfg} configLabel={currModel.title} modelsList={modelsList} loadedData={defaultSample[currModel.extID]} />
                            </div>
                        </div>
                        <ButtonGroup className="align-items-center">
                            <Button className="btn-simple btn-icon magnify" color="dark" size="sm" onClick={() => { if (zoomValue > 0) setZoomValue(zoomValue - 1) }}><i className="fa fa-magnifying-glass-minus"></i></Button>
                            <span className="mx-2">{(100 + zoomValue * 25) + "%"}</span>
                            <Button className="btn-simple btn-icon magnify" color="dark" size="sm" onClick={() => { if (zoomValue < 3) setZoomValue(zoomValue + 1) }}><i className="fa fa-magnifying-glass-plus"></i></Button>
                        </ButtonGroup>

                        {currModelHtml ? <div className="d-none"><AHTMLModel key={currModelHtml.idModel + currModelHtml.title} ref={reportGenHtmlManager} configModel={modelCfgHtml} loadedData={defaultSample[currModel.extID]} /></div> : ""}
                    </Col>);
                })() : ""}
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="secondary" onClick={() => { callback(); }}><i className="fa fa-times"></i>Fermer</Button>
            </ModalFooter>
        </Modal>
    );
}